import React from 'react';
import { Tooltip } from '@platform/base';
import Chart from './FormCardChart';
const defaultProps = {
    icon: 'icon_tongyong_1_purple',
    graphicType: 'icon',
};
const defaultImage = require(`../../../../static/images/formCardImageDefault.png`);
import * as svgIcons from './iconSvg';
class FormCardImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showTipMap: {} };
    }

    render() {
        return this.renderImage();
    }

    renderImage = () => {
        let { graphicType, icon = '#icon_tongyong_1_purple1', tooltips, areaCode, itemCode, meta = {}, pageScope, className = '', iconBackground = 'rgba(44,140,249,0.1)' } = this.props;
        let imgDom = null;
        let renderDisplay = this.renderDisplay(itemCode, areaCode, meta, pageScope);
        switch (graphicType) {
            case 'image':
                icon = renderDisplay || defaultImage || icon;
                imgDom = <Tooltip
                    placement="top"
                    overlay={tooltips}
                    delayHide={1}
                    delayShow={1000}
                >
                    <div
                        className={`form-card-img form-card-image-border ${className}`}
                        style={{ backgroundImage: `url("${icon}")` }}
                    >
                    </div>
                </Tooltip>;
                break;
            case 'chart':
                icon = renderDisplay || icon;
                imgDom = <Tooltip
                    placement="top"
                    overlay={tooltips}
                    delayHide={1}
                    delayShow={1000}
                >
                    <div
                    >
                        <Chart {...this.props} value={renderDisplay} className={`form-card-img form-card-chart ${className}`} />
                    </div>
                </Tooltip>;
                break;
            default:
                imgDom =
                    <Tooltip
                        placement="top"
                        overlay={tooltips}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <div
                            className={`form-card-img ${className}`}
                        >
                            <div className='form-card-img-icon' style={{ backgroundColor: iconBackground }}>
                                <img src={`${svgIcons[`${icon.replace('#', '').replace(/-/g, '_')}`]}`}/>
                            </div>
                        </div>
                    </Tooltip>;
                break;
        }
        return imgDom;
    }

    renderDisplay = (itemCode, areaCode, meta, pageScope) => {
        let mainFormId = areaCode;
        if (meta?.corerelation) {
            for (const key in meta.corerelation) {
                if (Object.hasOwnProperty.call(meta.corerelation, key)) {
                    const element = meta.corerelation[key];
                    element?.includes(areaCode) && meta[key]?.moduletype === 'form' && (mainFormId = key);
                }
            }
        }
        // 有可能这里配的是表单分组id，需要根据 formrelation 找到主表id
        if (meta?.formrelation) {
            for (const key in meta.formrelation) {
                if (Object.hasOwnProperty.call(meta.formrelation, key)) {
                    const element = meta.formrelation[key];
                    element?.includes(mainFormId) && meta[key]?.moduletype === 'form' && (mainFormId = key);
                }
            }
        }
        // 还有一种情况，配置的是多页签表单 tabs其他tab，需要根据 formassociatedrelation 找到主表id
        if (meta?.formassociatedrelation) {
            for (const key in meta.formassociatedrelation) {
                if (Object.hasOwnProperty.call(meta.formassociatedrelation, key)) {
                    const element = meta.formassociatedrelation[key]['formtabs'];
                    element?.includes(mainFormId) && meta[key]?.moduletype === 'form' && (mainFormId = key);
                }
            }
        }
        let row = pageScope?.formDataSource?.[mainFormId]?.getAllFormValue();
        let values = row?.[itemCode] || {};
        let value = values.display || values.value || '';
        return value;
    }
}

FormCardImage.defaultProps = defaultProps;
FormCardImage.displayName = 'FormCardImage';

export default FormCardImage;